import _ from 'lodash';

import * as constants from './Bookmark.constants';
import * as services from './Bookmark.service';

const state = {
  isRequest: false,
};

const mutations = {
  [constants.SET_IS_REQUEST_STATUS](state, status) {
    state.isRequest = status;
  },
};

const actions = {
  async getBookmark({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.getBookmark(payload);
    let bookmark = res.data.data;
    bookmark = bookmark ? bookmark : [];
    bookmark = _.map(bookmark, (video) => ({
      ...video,
      speed1: video.vpath,
      speed1Dot3: video.vpath_1_3,
      speed1Dot5: video.vpath_1_5,
      speed2: video.vpath_2,
      isNew: video.newPath,
    }));
    commit('Mixins/Bookmark/GET_BOOKMARK_SUCCESS', bookmark, { root: true });
    commit(constants.SET_IS_REQUEST_STATUS, false);
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
